import { NotificationState } from "./notifications.types";

export const state: NotificationState = {
  notifications: [],
  loading: false
};
